import React, { ReactNode } from 'react'
import HomeIcon from '@mui/icons-material/Home'
import EventIcon from '@mui/icons-material/Event'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import CustomAttributesIcon from '@mui/icons-material/AccountCircle'
import HealthMetricsIcon from '@mui/icons-material/ShowChart'

const PageRouteAndIcon = (route: string, icon: ReactNode) => ({
  route: route,
  icon: icon,
})

const InternalNavRoutes = {
  Home: PageRouteAndIcon('/', <HomeIcon />),
  Events: PageRouteAndIcon('/events', <EventIcon />),
  'Health & Compliance': PageRouteAndIcon(
    '/healthMetrics',
    <HealthMetricsIcon />,
  ),
  'Custom Attributes': PageRouteAndIcon(
    '/customAttributes',
    <CustomAttributesIcon />,
  ),
  'Custom Views': PageRouteAndIcon('/settingsViews', <CustomAttributesIcon />),
  Logout: PageRouteAndIcon('/logout', <ExitToAppIcon />),
}

export default InternalNavRoutes
